import { useNavigate, NavigateOptions } from 'react-router-dom';
import { useAppSelector } from '@/redux/store';
import { getRolePrefix } from '@/utility/RouteLinks';
import { getCookies, getRole } from '@/utility/helper';

export const useRoleNavigate = () => {
  const navigate = useNavigate();
  // Keep rolesMap from Redux — stable after login page loads roles
  const rolesMap = useAppSelector((state) => state.user.role);

  return (to: string, options?: NavigateOptions) => {
    // Read cookie inside the function (not at render time) to avoid the
    // race condition where cookie is set just before navigate() is called.
    const userRoleId = getCookies(`${import.meta.env.VITE_BUSINESS}role`);
    const activeRole = getRole(rolesMap, userRoleId);
    const prefix = getRolePrefix(activeRole?.name ?? '');

    const prefixedPath =
      to.startsWith('http') || to.startsWith('//')
        ? to
        : prefix + to;

    navigate(prefixedPath, options);
  };
};


